<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { onMounted, ref, defineProps } from 'vue';
import { useToastStore } from '@/stores/toast.store';
import { formatAmount, formatDateFrench } from '@/utils';
import axios from 'axios';
import CustomWidget from '@/components/CustomWidget.vue';

interface PrelevementMensuel {
    id: number;
    souscription_id: number;
    mois: number;
    date_prevision: string | null;
    date_operation: string | null;
    montant: number;
    statut: 'pending' | 'done' | 'cancelled';
    countdown: string | null;
}

const props = defineProps<{
    userId: number
}>();
const toastStore = useToastStore();
const loading = ref(false);
const stats = ref<{
    total_attendu: number,
    total_effectue: number,
    percent: number
}>({
    total_attendu: 0,
    total_effectue: 0,
    percent: 0
});
const prelevements = ref([] as any[]);
const minimized = ref(true);

onMounted(() => {
    loadPrelevementsMensuels();
});

async function loadPrelevementsMensuels() {
    try {
        loading.value = true;
        const httpResponse = await axios.get(`/backoffice/users/${props.userId}/prelevements_mensuels`);
        prelevements.value = httpResponse.data.items;
        stats.value = httpResponse.data.stats;
    } catch(e: any) {
        toastStore.error(e.message ?? "Une erreur est survenue lors de la requête au serveur");
    } finally {
        loading.value = false;
    }
}

async function validatePrelevementMensuel(detail: PrelevementMensuel) {
    loading.value = true;
    try {
        await axios.post(`/backoffice/users/${props.userId}/prelevements_mensuels/${detail.id}/validate`);
        await loadPrelevementsMensuels();
    } catch (e: any) {
        toastStore.error(e.message ?? "Une erreur est survenue lors de la requête au serveur");
    } finally {
        loading.value = false;
    }
}

</script>
<style lang="css" scoped>
.grid-minized {
    height: 350px;
    overflow: hidden;
}
</style>
<template>
    <custom-widget title="Prélèvement mensuel" :items="prelevements" :loading="loading">
        <template #action>
            <button class="btn lg py-3 black active">
                <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                <span>Exporter en PDF</span>
            </button>
            <button class="btn lg py-3 black active">
                <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                <span>Exporter en Excel</span>
            </button>
        </template>
        <template #header>
            <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                <div class="widget-floating py-0 text-xl flex-right">{{ stats.percent }}%</div>
                <div class="h-100p flex align-items-center rounded-100 px-7 bg-pop-green" :style="{'width': stats.percent + '%'}">
                    <h2>{{ formatAmount(stats.total_effectue) }} F</h2>
                    <h2 class="font-medium"> &nbsp;/ {{ formatAmount(stats.total_attendu) }} F</h2>
                </div>
            </div>
        </template>
        <template #item="{ item }">
            <div :class="{'active': item.statut == 'validated'}" class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5">
                <div class="s10">
                    <h6 class="secondary-font font-semibold mb-1">{{ formatDateFrench(item.date_prevision) }}</h6>
                    <h3 class="secondary-font font-semibold text-grey-900 py-1">{{ formatAmount(item.montant) }} F</h3>
                </div>
                <div class="s10 text-right">
                    <h5 class="secondary-font font-semibold text-grey-600 pb-2" v-if="item.statut == 'pending'">{{ item.countdown }}</h5>
                    <div class="mb-4" v-if="item.statut == 'validated'">
                        <span class="tag-state notif stroke">Effectué</span>
                    </div>
                    <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4" v-if="item.statut == 'validated'">{{ item.date_operation }}</h6>
                    <!-- <button class="btn-ultra w-100 shadow-0 display-none">
                        <div class="btn-show">
                            <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                            <span>Valider</span>
                        </div>
                        <div class="btn-loading">
                            <div class="loader-dots"></div>
                        </div>
                    </button> -->
                </div>
            </div>
        </template>
    </custom-widget>
</template>